
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySnowColour as ObiLightningHeavySnowColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-snow-colour.js';
 
 
 

 
 export const ObiLightningHeavySnowColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-snow-colour',
   elementClass: ObiLightningHeavySnowColourElement,
   events: {
     
   }
  });
 
 